import { FC } from 'react'

import { repeatFilterOptions } from '@new/__global/components/Filters/Filters.constants'

import { BookingRepeatView, FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface RepeatFilterProps extends FiltersSharedProps {
  title: string
  onChange: (value?: BookingRepeatView) => void
  initialValue?: BookingRepeatView
}

export const RepeatFilter: FC<RepeatFilterProps> = props => {
  return (
    <RadioBasedField radioGroupId="repeatFilterGroup" options={repeatFilterOptions} {...props} />
  )
}
